
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormService } from '@hub/services/form.service';
import { MenuItem } from '@hub/models/MenuItem';

@Component({
	selector: 'app-tab-view',
	templateUrl: './tab-view.component.html',
})
export class TabViewComponent implements OnInit {
	constructor(
		private router: Router,
		public formService: FormService,
	) {

	}
	moduleName: string;
	@Input() routeNavbarItems: MenuItem[];

	ngOnInit(): void {
	}

	menuItemClick(routerLinkVlaue: any[]) {
	}

}
